import { createContext } from "react";

export interface AuthState {
  /** True when OKTA is configured and the user is signed in, OR in local no-auth mode. */
  isAuthenticated: boolean;
  /** Whether OKTA is configured at all (false => local no-auth mode). */
  authEnabled: boolean;
  loading: boolean;
  /** Display name / email of the signed-in user, or a local placeholder. */
  actor: string;
  /** Begins the OKTA redirect. Returns a promise so callers can await/catch failures. */
  login: () => Promise<void> | void;
  logout: () => void;
}

export const AuthContext = createContext<AuthState>({
  isAuthenticated: true,
  authEnabled: false,
  loading: false,
  actor: "local-operator",
  login: () => {},
  logout: () => {},
});
